/*
  Scope & Field: Complete the kit.
  Listens for Dawn's cartUpdate event from this section's product form. When the main product has been
  added, it adds each ticked add-on as its own line through /cart/add.js, then refreshes the cart drawer
  (or the basket icon when the drawer is off). No discounts are applied here.
*/
if (!customElements.get('sf-complete-the-kit')) {
  customElements.define(
    'sf-complete-the-kit',
    class SfCompleteTheKit extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.error = this.querySelector('.sf-kit__error');
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.onCartUpdate(event));
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      mainVariantId() {
        const form = document.getElementById(`product-form-${this.sectionId}`);
        const input = form ? form.querySelector('[name="id"]') : null;
        return input ? String(input.value) : null;
      }

      checkedItems() {
        return Array.from(this.querySelectorAll('.sf-kit__checkbox:checked')).map((box) => ({
          id: Number(box.value),
          quantity: 1,
        }));
      }

      async onCartUpdate(event) {
        if (!event || event.source !== 'product-form' || this.busy) return;
        if (String(event.productVariantId) !== this.mainVariantId()) return;
        const items = this.checkedItems();
        if (!items.length) return;

        this.busy = true;
        if (this.error) this.error.hidden = true;
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer ? drawer.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'];

        try {
          const response = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'Add failed');

          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(data);
          } else if (data.sections && data.sections['cart-icon-bubble']) {
            const bubble = document.getElementById('cart-icon-bubble');
            const html = new DOMParser()
              .parseFromString(data.sections['cart-icon-bubble'], 'text/html')
              .querySelector('.shopify-section');
            if (bubble && html) bubble.innerHTML = html.innerHTML;
          }
          this.querySelectorAll('.sf-kit__checkbox:checked').forEach((box) => (box.checked = false));
        } catch (e) {
          console.error(e);
          if (this.error) this.error.hidden = false;
        } finally {
          this.busy = false;
        }
      }
    }
  );
}
